export const featureTypes = [
  // user has selected a portion of the sample graph, or
  // user has modified a previously selected feature using
  // the sample graph drag handles.
  //
  // data shape: {highlightSlice}
  'SAMPLE_GRAPH_USER_SELECTION',
  // user has clicked or hovered a segment match in the sidebar
  //
  // data shape: {highlightSlice, segmentMatch}
  'SEGMENT_MATCH',
  // user has clicked or hovered a climb/descent in the sidebar
  //
  // data shape: {highlightSlice, hill}
  'HILL',
  // user has hovered the map or sample graph in a way that should cause
  // a highlight point to appear
  'POINT_GENERIC',
  // user has clicked or hovered a metric that refers to a specific point
  // on the map/graph (max heart rate, max elevation, etc)
  //
  // data shape: {highlightPoint}
  'POINT_METRIC',
  // user has clicked or hovered a cue
  //
  // data shape: {index, coursePoint}
  'CUE'
].reduce((obj, type) => ({...obj, [type]: type}), {})
